import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { plainToClass } from 'class-transformer';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { UserPreferencesModel } from './user-preferences.model';

/**
 * Service to save user preferences.
 */
@Injectable()
export class UserPreferencesService {
    constructor(private requestService: ObservableRequestService) { }

    saveUserPreferences(body: Object): Observable<any> {
        const userPreferencesUrl = ConstantsService.USER_PREFERENCES_URL;
        return this.requestService
            .postRequest(userPreferencesUrl,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };

    getUserPreferences(loginId: string): Observable<any> {
        return this.requestService
            .getRequest(ConstantsService.GET_USER_PREFERENCES + loginId)
            .map(response => {
                return plainToClass(UserPreferencesModel, response.arrResult as Object);
            });
    }

    getMSExchangeUrl(exchangeEmailId: string, exchangePswd: string): Observable<any> {
        return this.requestService
            .getRequest(ConstantsService.AUTO_DETECT_EWS_URL
            + 'exchangeEmailId=' + exchangeEmailId + '&exchangePwd=' + exchangePswd);
    }
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/userpreferences/user-preferences.service.ts